import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const TermsOfService = () => (
  <>
    <Helmet>
      <title>Terms of Service | Elara Health</title>
      <meta name="description" content="Terms of Service governing your use of the Elara Health platform, telehealth consultations, and peptide therapy protocols." />
      <link rel="canonical" href="https://elarahealth.life/terms" />
      <meta property="og:title" content="Terms of Service | Elara Health" />
      <meta property="og:url" content="https://elarahealth.life/terms" />
    </Helmet>
    <Navbar />
    <main className="min-h-screen pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="font-display text-4xl md:text-5xl text-foreground mb-6">Terms of Service</h1>
        <div className="prose prose-lg text-muted-foreground space-y-4">
          <p><em>Last updated: {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</em></p>
          <p>
            By accessing or using the Elara Health platform, you agree to be bound by these Terms of Service.
            Please read them carefully before using our services.
          </p>
          <h2 className="font-display text-2xl text-foreground">Eligibility</h2>
          <p>You must be at least 18 years old and located in a state where our services are available to use this platform.</p>
          <h2 className="font-display text-2xl text-foreground">Medical Disclaimer</h2>
          <p>Our platform facilitates telehealth consultations with licensed providers. Treatment decisions are made by your provider based on clinical judgment. Elara Health does not guarantee specific outcomes.</p>
          <h2 className="font-display text-2xl text-foreground">Payments & Refunds</h2>
          <p>Subscription and consultation fees are outlined at the time of purchase. Refund policies are communicated during checkout.</p>
          <p>For questions, contact <a href="mailto:legal@elarahealth.life" className="text-champagne hover:underline">legal@elarahealth.life</a>.</p>
        </div>
      </div>
    </main>
    <Footer />
  </>
);

export default TermsOfService;
